<ion-content>
  <ion-grid style="margin: 3px">
    <!-- Tenant Selection -->
    <ion-row>
      <ion-col>
        <ion-card>
          <ion-card-header>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div>
                <ion-card-title>Select Tenant</ion-card-title>
                <ion-card-subtitle
                  >Choose a tenant to view knowledge gap
                  insights</ion-card-subtitle
                >
              </div>
              <ion-searchbar
                mode="ios"
                class="rounded-search-bar"
                placeholder="Search tenants..."
                showCancelButton="never"
                [value]="tenantSearchText"
                (ionInput)="tenantSearchText = $event.target.value"
                style="width: 270px; margin: 0"
              >
              </ion-searchbar>
            </div>
          </ion-card-header>
          <ion-card-content>
            <ngx-datatable
              #tenantTable
              [rows]="
                tenants$
                  | async
                  | filterCollection
                    : tenantSearchText
                    : ['name', 'id', 'subdomain']
              "
              [columns]="tenantColumns"
              [columnMode]="ColumnMode.flex"
              [headerHeight]="50"
              [footerHeight]="0"
              [rowHeight]="60"
              [limit]="1000"
              [selectionType]="SelectionType.single"
              [selected]="selected"
              (select)="onTenantSelect($event)"
              class="bootstrap"
            >
            </ngx-datatable>

            <div *ngIf="isLoadingTenants" class="loading-state">
              <ion-spinner></ion-spinner>
              <p>Loading tenants...</p>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
